import { render, staticRenderFns } from "./BaseTableFiltered.vue?vue&type=template&id=8572e66a&"
import script from "./BaseTableFiltered.vue?vue&type=script&lang=js&"
export * from "./BaseTableFiltered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports